import { axiosJwt } from '@/shared/auth/axiosJwt';

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_SOL}${process.env.VUE_APP_API_PATH}/sol`;

const urlBase = `${api}/areas`;

export default {
    obterTodos(active) {
        active == null ? active = '' : active
        return axiosJwt.get(`${urlBase}?active=${active}`);
    },
    obterPorId(id) {
        return axiosJwt.get(`${urlBase}/${id}`);
    },
    excluir(id) {
        return axiosJwt.delete(`${urlBase}/${id}`);
    },
    inserir(area) {
        return axiosJwt.post(`${urlBase}`, area);
    },
    atualizar(id, area) {
        return axiosJwt.put(`${urlBase}/${id}`, area);
    },
    obterTematicaSas() {
        return axiosJwt.get(`${api}/sas/tematicas`);
    },
};
